module.exports = __webpack_public_path__ + "static/logo-4e5c2d2b517e289fe5ef8f71b6e7353a.png";